<template>
  <nav class="breadcrumb has-succeeds-separator is-small" aria-label="breadcrumbs">
    <ul class="vs-crumbs" v-if="crumbs.length">
      <li v-for="(crumb, i) in crumbs" :key="i">
        <router-link :to="crumb.path"> {{ crumb.name }} </router-link>
      </li>
    </ul>
  </nav>

  
</template>

<script>
  /*=============================================================================
    Created by NxtChg (admin@nxtchg.com), 2017. License: Public Domain.
  =============================================================================*/
  export default {
    name: 'Breadcrumd',
    props: { root: String },
    computed:
    {
      crumbs: function()
      {
        let path = '', title = (this.root || 'หน้าแรก');
        let cs = [ { name: title, path: '/'} ]; if(!this.$route) return [];
        let r = (this.$route.path                        ).split('/');
        let m = (this.$route.matched[1].meta.crumbs || '').split('/');

        for(let i = 1; i < r.length; i++)
        {
          let name = (m[i] || r[i]); if(r[i] == '') continue;
          if(name != "*"){
            path  += '/'  + r[i];
            cs.push({ name: name, path: path });
          }else{
            cs[cs.length-1].path += "/"+r[i];
          }
          
        }
        return cs;
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue